import { render, staticRenderFns } from "./schedule-notify.vue?vue&type=template&id=2963696e&"
import script from "./schedule-notify.vue?vue&type=script&lang=js&"
export * from "./schedule-notify.vue?vue&type=script&lang=js&"
import style0 from "./schedule-notify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports